import React from "react";
import { Route, Routes } from "react-router";
import loadable from "@loadable/component";
import { useTamanoPantalla } from "contexts/providers";
import { RUTAS_TURBANTES } from "constants/rutasTurbantes";

const Home = loadable(() => import("components/home/web"), {
  resolveComponent: (components) => components.Home
});
const HomeMobile = loadable(() => import("components/home/mobile"), {
  resolveComponent: (components) => components.Home
});
const FloradibujaViews = loadable(() => import("components/floradibuja"), {
  resolveComponent: (components) => components.FloradibujaViews
});
const DisenoGraficoViews = loadable(() => import("components/disenoGrafico"), {
  resolveComponent: (components) => components.DisenoGraficoViews
});
const DisenoTextilViews = loadable(() => import("components/disenoTextil"), {
  resolveComponent: (components) => components.DisenoTextilViews
});
const FotografiaViews = loadable(() => import("components/fotografia"), {
  resolveComponent: (components) => components.FotografiaViews
});
const RedesSocialesViews = loadable(() => import("components/redesSociales"), {
  resolveComponent: (components) => components.RedesSocialesViews
});
const TurbantesViews = loadable(() => import("components/turbantes"), {
  resolveComponent: (components) => components.TurbantesViews
});
const SolicitudPresupuestoViews = loadable(
  () => import("components/solicitudPresupuesto"),
  {
    resolveComponent: (components) => components.SolicitudPresupuestoViews
  }
);

export const AppViews: React.FC = () => {
  const { isMobile } = useTamanoPantalla();

  return (
    <Routes>
      <Route index element={isMobile ? <HomeMobile /> : <Home />} />
      <Route path={`/floradibuja/*`} element={<FloradibujaViews />} />
      <Route path={`/disenoGrafico/*`} element={<DisenoGraficoViews />} />
      <Route path={`/disenoTextil/*`} element={<DisenoTextilViews />} />
      <Route path={`/fotografia/*`} element={<FotografiaViews />} />
      <Route path={`/social/*`} element={<RedesSocialesViews />} />
      <Route
        path={`/solicitudPresupuesto/*`}
        element={<SolicitudPresupuestoViews />}
      />
      {/* Landing de campaña: una ruta por público, fuera de los menús. */}
      {Object.entries(RUTAS_TURBANTES).map(([ruta, variante]) => (
        <Route
          key={ruta}
          path={`${ruta}/*`}
          element={<TurbantesViews variante={variante} />}
        />
      ))}
    </Routes>
  );
};
